import {
    LOAD_CLIENTS,
    LOADED_CLIENTS_SUCCESS,
    LOADED_CLIENTS_FAILURE,
} from '../actions';

const initialState = {
    fetching: false,
    error: undefined,
    content: [],
    meta: undefined,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_CLIENTS:
            return {
                ...state,
                error: undefined,
                fetching: true,
            };
        case LOADED_CLIENTS_SUCCESS:
            return {
                ...state,
                content: action.payload.content,
                meta: action.payload.meta,
                fetching: false,
            };
        case LOADED_CLIENTS_FAILURE:
            return {
                ...state,
                content: action.payload.content,
                meta: action.payload.meta,
                fetching: false,
            };
        default:
            return state;
    }
};

export default reducer;
